module.exports = __webpack_public_path__ + "img/site.edaca572.png";